var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { cloneDeep, set } from 'lodash';
import { useEffect, useState } from 'react';
function useForm(_a) {
    var initialValues = _a.initialValues, validate = _a.validate, onValidSubmit = _a.onValidSubmit, onInvalidSubmit = _a.onInvalidSubmit;
    var _b = useState(initialValues || null), values = _b[0], setValues = _b[1];
    var _c = useState(null), errors = _c[0], setErrors = _c[1];
    var _d = useState(false), isDifferentFromInitial = _d[0], setIsDifferentFromInitial = _d[1];
    var _e = useState(false), isPressedSubmit = _e[0], setIsPressedSubmit = _e[1];
    var _f = useState(false), validationTriggeredManually = _f[0], setValidationTriggeredManually = _f[1];
    useEffect(function () {
        if (initialValues !== undefined) {
            setValues(initialValues);
        }
        else {
            setValues(null);
        }
        setErrors(null);
        setIsDifferentFromInitial(false);
    }, [initialValues]);
    function onChange(e) {
        return __awaiter(this, void 0, void 0, function () {
            var name, isCheckbox, value;
            return __generator(this, function (_a) {
                name = e.target.name;
                isCheckbox = e.target.type === 'checkbox';
                value = isCheckbox ? e.target.checked : e.target.value;
                // Set value
                onChangeValue(name, value);
                return [2 /*return*/];
            });
        });
    }
    function onChangeValue(field, value) {
        var newValues = values;
        // Set new value in the cloned values object
        setValues(function (oldValues) {
            var clonedValues = oldValues ? cloneDeep(oldValues) : {};
            var values = set(clonedValues, field, value);
            newValues = values;
            handleValueChange(values);
            return newValues;
        });
        return newValues;
    }
    function handleValueChange(newValues) {
        // Change isDifferentFromInitial status on first change
        if (!isDifferentFromInitial) {
            setIsDifferentFromInitial(true);
        }
        // Check again, if submit has already been pressed once
        if (isPressedSubmit || validationTriggeredManually) {
            validateValues(newValues, false);
        }
    }
    function handleSubmit(e, options) {
        if (e) {
            e.preventDefault();
        }
        setIsPressedSubmit(true);
        if (validationTriggeredManually) {
            setValidationTriggeredManually(false);
        }
        var passedValidation = validateValues(values, true);
        if (!passedValidation) {
            return;
        }
        // Reset the form status
        setErrors(null);
        setIsDifferentFromInitial(false);
        // Send back to form
        if (values) {
            onValidSubmit(values, options);
            setIsPressedSubmit(false);
        }
    }
    function validateValues(valuesToValidate, checkingOnSubmit) {
        // If no validate function is passed, mark form always as valid
        if (!validate) {
            return true;
        }
        // If there are no values, set errors to null, but don't send a valid submit
        if (!valuesToValidate) {
            setErrors(null);
            if (checkingOnSubmit && onInvalidSubmit) {
                onInvalidSubmit();
            }
            return false;
        }
        // Call the validate function the user passed
        var validatedValues = validate(valuesToValidate);
        // If there are any errors send them back to the user, and send an invalid submit
        if (validatedValues && Object.values(validatedValues).find(function (errorMessage) { return errorMessage !== null; })) {
            // At least one error found
            setErrors(validatedValues);
            if (checkingOnSubmit && onInvalidSubmit) {
                onInvalidSubmit(errors);
            }
            return false;
        }
        // Error checking passed, clear the errors and return valid pass confirm
        setErrors(null);
        return true;
    }
    function triggerValidation() {
        setValidationTriggeredManually(true);
        validateValues(values, false);
    }
    function onChangeErrors(value) {
        setErrors(value);
    }
    function setAllValues(newValues) {
        setIsDifferentFromInitial(true);
        setValues(newValues);
    }
    function cancelChanges() {
        setValues(initialValues || null);
        setErrors(null);
        setIsDifferentFromInitial(false);
        setIsPressedSubmit(false);
    }
    return {
        handleSubmit: handleSubmit,
        values: values,
        errors: errors,
        onChange: onChange,
        onChangeValue: onChangeValue,
        onChangeErrors: onChangeErrors,
        triggerValidation: triggerValidation,
        isDifferentFromInitial: isDifferentFromInitial,
        setAllValues: setAllValues,
        cancelChanges: cancelChanges,
    };
}
export default useForm;
//# sourceMappingURL=UseForm.js.map